import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import styled, { css } from 'styled-components';
import noImageUrl from 'assets//noimage.png';

const backgroundImage = (imageURL, size) => css`
    background-image: url("${imageURL}");
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: ${size};
  `;

const Container = styled.div`
  grid-area: media;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  padding: 10px;
  ${(props) => backgroundImage(props.url, 'contain')}
`;

const MediaContainer = () => {
  const {
    BidStore: { auction },
  } = useStores();

  const { url } = auction;

  return <Container url={url ?? noImageUrl} />;
};

export default observer(MediaContainer);
